const _excluded = ["illustrationType", "title", "description", "action", "footer", "onLogout", "color", "style"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import PropTypes from 'prop-types';
import { PublicPageLayout } from '@adsk/alloy-project-page-layout';
import { Box, Flex } from '@adsk/alloy-react-box';
import { LinkButton } from '@adsk/alloy-react-button';
import EmptyState from '@adsk/alloy-react-empty-state';
import { useLocale } from '@adsk/alloy-react-locale';
import { stylePropType } from '@adsk/alloy-react-theme';
export const DefaultAction = _ref => {
  let {
    onRetry = () => window.location.reload()
  } = _ref;
  const {
    T
  } = useLocale(_ref2 => {
    let {
      locale
    } = _ref2;
    return require("./i18n/".concat(locale, ".json"));
  });
  return /*#__PURE__*/React.createElement(LinkButton, {
    onClick: () => onRetry === null || onRetry === void 0 ? void 0 : onRetry()
  }, T.translate('TRY_AGAIN'));
};
/**
 * An ErrorPage component. Used to show a generic error page when no other option exists.
 * Can be used as a fallback when using a page level ErrorBoundary for example.
 */
const ErrorPage = /*#__PURE__*/React.forwardRef((_ref3, ref) => {
  let {
      illustrationType = EmptyState.ILLUSTRATION_TYPES.BUILDING_CONSTRUCTION_GREY,
      title,
      description,
      action,
      footer,
      onLogout,
      color: _color,
      // this prop is ignored to fix an error with Box getting wrong color type
      style
    } = _ref3,
    props = _objectWithoutProperties(_ref3, _excluded);
  const {
    T
  } = useLocale(_ref4 => {
    let {
      locale
    } = _ref4;
    return require("./i18n/".concat(locale, ".json"));
  });
  const finalTitle = title || T.translate('ERROR_PAGE_TITLE');
  const finalDescription = description || T.translate('ERROR_PAGE_DESCRIPTION');
  const finalAction = action || /*#__PURE__*/React.createElement(DefaultAction, null);
  return /*#__PURE__*/React.createElement(PublicPageLayout, {
    onLogout: onLogout,
    ref: ref
  }, /*#__PURE__*/React.createElement(Flex, _extends({
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    style: style
  }, props), /*#__PURE__*/React.createElement(EmptyState, {
    title: finalTitle,
    illustrationType: illustrationType,
    description: finalDescription,
    size: EmptyState.SIZES.LARGE
  }, /*#__PURE__*/React.createElement(React.Fragment, null, finalAction && /*#__PURE__*/React.createElement(Box, {
    typography: "heading2"
  }, finalAction), footer && /*#__PURE__*/React.createElement(Box, {
    marginTop: 72,
    typography: "bodyLargeBold",
    color: "charcoal700"
  }, footer)))));
});
ErrorPage.displayName = 'ErrorPage';
ErrorPage.propTypes = {
  /** Styles applied to the root element */
  style: stylePropType,
  /** Class applied to the root element */
  className: PropTypes.string,
  /** Illustration type */
  illustrationType: PropTypes.oneOf(Object.values(EmptyState.ILLUSTRATION_TYPES)),
  /** Error page title */
  title: PropTypes.node,
  /** Error page description */
  description: PropTypes.node,
  /** Error page action */
  action: PropTypes.node,
  /** Error page footer */
  footer: PropTypes.node,
  /** callback called on logout */
  onLogout: PropTypes.func
};
export default Object.assign(ErrorPage, {
  ILLUSTRATION_TYPES: EmptyState.ILLUSTRATION_TYPES
});
//# sourceMappingURL=ErrorPage.js.map